module.exports = "/assets/data/eec43470c2fbccddd1871d344f0b1c23-NN29.data.json";